
export default  class CreateOrderProductInfo {
    url: string;
    productName: string;
    count: number;
    id: number;
    constructor() {
        this.count = null;
    }
}